import React, { useContext } from 'react';
import { RicosContext, EditorContext, ModalContext, PluginsEventsContext } from 'ricos-context';
import SocialEmbedInsertModal from '../toolbar/SocialEmbedInsertModal.js';
import { socialModals } from '../consts.js';
import { EMBED_TYPE } from 'wix-rich-content-common';
import 'prop-types';
import 'wix-rich-content-ui-components';
import '../types.js';
import '../defaults.js';
import '../dataHooks.js';
import 'ricos-schema';

const InsertModal = ({
  componentData,
  fetchData,
  nodeId,
  socialType,
  showCloseButton
}) => {
  const { t, isMobile, languageDir, experiments } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalContext) || {};
  const pluginsEvents = useContext(PluginsEventsContext);
  const closeModal = () => {
    modalService.closeModal(socialModals[socialType.toLowerCase()]);
  };
  const onConfirm = (embedData) => {
    const editorCommands = getEditorCommands();
    if (nodeId) {
      editorCommands == null ? void 0 : editorCommands.setBlock(nodeId, EMBED_TYPE, embedData);
    } else {
      editorCommands == null ? void 0 : editorCommands.insertBlockWithBlankLines(EMBED_TYPE, embedData);
    }
  };
  const pluginEvents = {
    onPluginsPopOverClick: (data) => pluginsEvents.publishPluginPopoverClick(data)
  };
  return /* @__PURE__ */ React.createElement(
    SocialEmbedInsertModal,
    {
      componentData,
      t,
      isMobile,
      languageDir,
      onConfirm,
      closeModal,
      fetchData,
      socialType,
      experiments,
      helpers: pluginEvents,
      showCloseButton
    }
  );
};

export { InsertModal as default };
//# sourceMappingURL=InsertModal.js.map
